//menu
var app = app || {};
(function ($) {
   app.overlay = new function () {

      var _self = this;
      this.xhr = false;
      this.previousUrl = false; //previous URL before overlay was opened
      this.previousMetaTitle = false;
      this.inlineID = false; //id of the inline content dom
      this.inlineHTML = false; //content of the inline content dom
      this.previousScrollPosition = 0;
      this.init = function () {
         $(document).on('click.ajaxOverlay', '.js-overlay-ajax', function (e) {
            var wrapperClass = $(this).attr('data-overlay-wrapper') || false;
            if (!$('body').hasClass('overlay-on-scrollable')) {
               _self.previousUrl = window.location.href;
               _self.previousMetaTitle = $('title').html();
            }


            var href = $(this).attr('href');

            $.get(href, function (data) {
               var html = app.core.parseHTML(data);
               _self.openOverlay({ html: html.ajaxContent, wrapperClass: wrapperClass });
               if (html.title != '') {
                  $('title').html(html.title);
               }
               app.core.replaceUrl(href);
               //trigger page view
               app.core.gaPageview();

            });
            e.preventDefault();
         });

         $(document).on('click.overlay', '.js-overlay-close', function (e) {
            _self.closeOverlay();
            //trigger page view
            app.core.gaPageview();
         });

         $(document).on('click.overlayIframe', '.js-overlay-iframe', function (e) {
            var html = '<iframe allow="autoplay; fullscreen" class="overlay__iframe" src="' + $(this).attr('href') + '"></iframe>';
            var wrapperClass = $(this).attr('data-overlay-wrapper') || false;
            _self.openOverlay({ html: html, wrapperClass: wrapperClass });
            e.preventDefault();
         });

         $(document).on('click.overlayinline', '.js-overlay-inline', function (e) {
            _self.inlineID = $(this).attr('data-overlay-id');
            _self.previousUrl = window.location.href;
            history.pushState({}, "", '#' + _self.inlineID);

            var $content = $('#' + _self.inlineID);
            if ($content.length) {
               if ($content.parents('.js-overlay-parent').length) {
                  _self.inlineID = $content.parents('.js-overlay-parent').attr('id');
                  $content = $('#' + _self.inlineID);
               }
               _self.inlineHTML = $content.html();

               $content.html('');
               var wrapperClass = $(this).attr('data-overlay-wrapper') || false;
               _self.openOverlay({ html: _self.inlineHTML, wrapperClass: wrapperClass });

            }

            e.preventDefault();
         });

         $(document).on('click.overlayIframe', '.js-overlay-image', function (e) {
            var html = '<img class="overlay__img" src="' + $(this).attr('href') + '"/><div class="overlay__downloadimage"><a href="' + $(this).attr('href') + '" download><span class="btn">Download graphic</span></a></div>';
            var wrapperClass = $(this).attr('data-overlay-wrapper') || 'image';
            _self.openOverlay({ html: html, wrapperClass: wrapperClass });
            e.preventDefault();
         });





         // $('.overlay__shadow').on('click.overlay', function (e) {
         //    if (!$(e.target).closest('.overlay__width').length) {
         //       _self.closeOverlay();
         //    }

         // });

         $(document).on('app:escape', function () {
            _self.closeOverlay();
         });

         //open overlay if target id is in the hash

         if (window.location.hash) {
            let hashId = window.location.hash.replace('#', '');
            let $inlineOverlay = $('[data-overlay-id="' + hashId + '"');
            $inlineOverlay.trigger('click');
         }


      };




      this.loadIframe = function (params) {


         app.menu.openOverlay(params);

      };

      this.openOverlay = function (params) {
         var wrapperClass = params.wrapperClass || 'default';
         var html = params.html || false;

         if (wrapperClass) {
            $('.overlay').removeAttr('class').attr('class', 'overlay ' + wrapperClass);
         }
         else {
            $('.overlay').removeAttr('class').attr('class', 'overlay');
         }

         if (html) {
            $('.overlay__content').html(html);
         }
         $('.overlay').attr('aria-hidden', 'false');

         $('.overlay__inner').scrollTop(0).focus();

         _self.previousScrollPosition = parseInt($(window).scrollTop());
         $('.overlay-fixed').css({ top: -_self.previousScrollPosition });

         //
         var $collectionSubMenu = $('.collections__menu');
         var $subMenu = $('.submenu-section');

         if ($collectionSubMenu.length && _self.previousScrollPosition >= parseInt($collectionSubMenu.offset().top) - parseInt($collectionSubMenu.css('top'))) {
            $collectionSubMenu.addClass('fixed');

         }
         if ($subMenu.length && _self.previousScrollPosition >= parseInt($subMenu.offset().top) - parseInt($subMenu.css('top'))) {
            $subMenu.addClass('fixed');

         }

         $('body').removeClass(function (index, className) {
            return (className.match(/(^|\s)overlaycustom-\S+/g) || []).join(' ');
         });
         $('body').addClass('overlay-on-scrollable overlaycustom-' + wrapperClass);
         $(window).scrollTop(0);



         $(document).trigger('app:contentLoaded');
         $(document).trigger('app:bodyUpdate');

         //aria tab index
         app.aria.tabIndex.disableAll($('body'));
         app.aria.tabIndex.enableVisible($('.overlay'));


      };
      this.closeOverlay = function () {
         _self.hideOverlay();
         setTimeout(function () {
            $('.overlay__content').html('');
         }, 500);
         if (_self.previousUrl) {
            app.core.replaceUrl(_self.previousUrl);
         }
         if (_self.previousMetaTitle) {
            $('title').html(_self.previousMetaTitle);
         }

         if (_self.inlineID) {
            $('#' + _self.inlineID).html(_self.inlineHTML);
            _self.inlineID = false;
            app.core.replaceUrl(_self.previousUrl);
         }
         app.aria.tabIndex.enableVisible($('body'));
      };

      this.hideOverlay = function () {
         $('.overlay').addClass('overlay--hidden').attr('aria-hidden', 'true');
         $('.overlay-fixed').removeAttr('style');
         $('.collections__menu').removeClass('fixed');
         $('.submenu-section').removeClass('fixed');

         $('body').removeClass('overlay-on-scrollable overlay-on-scrollable-absolute');
         $('body').removeClass(function (index, className) {
            return (className.match(/(^|\s)overlaycustom-\S+/g) || []).join(' ');
         });
         $(window).scrollTop(_self.previousScrollPosition);
         $(document).trigger('app:bodyUpdate');
      };
   };
   app.overlay.init();


})(jQuery);
